import { render, staticRenderFns } from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=template&id=47f0d500&"
import script from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports